export default class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.bindToHeader = this.dataset.bindToHeader === 'true' || this.dataset.bindToHeader === true;
    this.shopifySection = null;
    this.header = null;
  }

  connectedCallback() {
    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', this.init.bind(this))
      : this.init();
  }

  disconectedCallback() {}

  init() {
    this.shopifySection = this.closest('.shopify-section');
    this.header = document.querySelector('.header');

    if (this.closest('.header-wrapper')) {
      return;
    }

    if (!this.header) {
      return;
    }

    if (this.bindToHeader) {
      this.removeExistingBar();
      this.moveBarToHeader();
    }
  }

  moveBarToHeader() {
    this.shopifySection.style.display = 'none';
    this.header.parentNode.insertBefore(this, this.header);
  }

  removeExistingBar() {
    const headerAnnouncementBar = this.header.parentElement.querySelector('announcement-bar');

    if (headerAnnouncementBar) {
      headerAnnouncementBar.remove();
    }
  }
}
